import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Box, Grid, MenuItem, Typography } from '@mui/material'

import InputFormikField from '@/views/components/input-formik-field/index.component'
import { ApplicationState } from '@/state'

export const MobileNumberPersonalInfo = () => {
  const { t } = useTranslation()

  const { countriesList } = useSelector(
    ({ playerCard }: ApplicationState) => playerCard,
  )

  const countries = countriesList.map((country) => {
    return (
      <MenuItem key={country.iso2} value={country.iso2}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={`https://flagcdn.com/w80/${country.iso2.toLowerCase()}.png`}
            width="20"
            height="15"
            alt={country.iso2.toUpperCase()}
          />
          <Typography
            variant="body2"
            sx={{ paddingLeft: 0.5 }}
          >{`${country.name} (+${country.phone[0]})`}</Typography>
        </Box>
      </MenuItem>
    )
  })

  return (
    <>
      <Grid item xs={6}>
        <InputFormikField
          label={t('labels.numberCode')}
          name="mobileCountryCode"
          select
          sx={{
            '& .MuiSelect-select': {
              display: 'flex',
              maxHeight: '16px',
            },
          }}
        >
          {countries}
        </InputFormikField>
      </Grid>
      <Grid item xs={6}>
        <InputFormikField
          label={t('labels.mobileNumber')}
          name="mobileNumber"
        />
      </Grid>
    </>
  )
}
